import { render } from "./FaqView.vue?vue&type=template&id=5ab64f15&scoped=true"
import script from "./FaqView.vue?vue&type=script&lang=js"
export * from "./FaqView.vue?vue&type=script&lang=js"

import "./FaqView.vue?vue&type=style&index=0&id=5ab64f15&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab64f15"]])

export default __exports__